import type { Maybe } from '@/types'

export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}

export type MakeRequired<T, K extends keyof T> = T & {
  [SubKey in K]-?: T[SubKey]
}

export type MakePartial<T, K extends keyof T> = T & {
  [SubKey in K]: Partial<T[SubKey]>
}

export type PartialBy<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>

export type UnpackArray<T> = T extends (infer R)[] ? R : T

export type Enumerate<
  N extends number,
  Acc extends number[] = []
> = Acc['length'] extends N
  ? Acc[number]
  : Enumerate<N, [...Acc, Acc['length']]>

export type IntRange<F extends number, T extends number> = Exclude<
  Enumerate<T>,
  Enumerate<F>
>

export function isNumber(value: unknown): asserts value is number {
  if (!Number.isInteger(value)) throw new Error('Not a number!')
}
/**
 * TODO: придумать решение получше
 * */
export function isT<T>(value: unknown): asserts value is T {
  if (!value) throw new Error(`Error!`)
}

export function enumToArr(value: any) {
  return Array.from(new Map(Object.entries(value)), ([, value]) => value)
}
